<template>
  <div>
    <b-container fluid>
      <h3 class="mt-3 mb-3">Redemption Location</h3>

      <b-pagination
        size="sm"
        :total-rows="total_rows"
        v-model="currentPage"
        :per-page="TABLE_LIMIT"
        @change="onPageChange"
        :limit="PAGING_LIMIT"
      ></b-pagination>

      <b-table
        responsive
        small
        outlined
        striped
        hover
        sticky-header="500px"
        :items="items"
        :fields="fields"
      >
      </b-table>

      <b-pagination
        size="sm"
        :total-rows="total_rows"
        v-model="currentPage"
        :per-page="TABLE_LIMIT"
        @change="onPageChange"
        :limit="PAGING_LIMIT"
      ></b-pagination>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "CompanyMaster",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT"],
  components: {},
  data() {
    return {
      courier_options: [],
      upload_file: false,
      loader_full: false,
      items: [],
      fields: [
        {
          key: "company_name",
          label: "Company Name"
        },
        {
          key: "address",
          label: "Address"
        }
      ],
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      search_criteria: {
        keyword: "",
        status_selected: null
      }
    };
  },
  async created() {
    await this.getCompanys();
    this.initialized = true;
  },
  mounted() {
    this.loader_full = this.$loading.show({
      isFullPage: true,
      canCancel: false
    });
  },
  methods: {
    displayDate(d) {
      if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },

    async getCompanys() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "company_get.php",
        data: {
          offset: this.table_offset,
          limit: this.TABLE_LIMIT,
          search_criteria: this.search_criteria,
          user_id: this.$store.state.user_obj.user_id,
          client_id: this.$store.state.user_obj.client_id
        }
      });
      this.items = response.data.companys;
      this.total_rows = parseInt(response.data.total_rows);
      this.loader_full.hide();
    },

    onSearch() {
      for (const key in this.search_criteria) {
        if (typeof this.search_criteria[key] === "string") {
          this.search_criteria[key] = this.search_criteria[key].trim();
        }
      }
      this.getCompanys();
    },

    onPageChange(page_to_change) {
      this.table_offset = (page_to_change - 1) * this.TABLE_LIMIT;
      this.getCompanys();
    }
  }
};
</script>

<style>
th,
td {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/CompanyMaster.vue